import { CommonModule } from '@angular/common';
import { Component, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { NodeIconPipe } from '@features/flow-ui-creator/pipes/node-icon.pipe';
import { generateColorRGB } from '@marko19907/string-to-color';
import { ReteModule } from 'rete-angular-plugin/21';
import { BaseNodeComponent } from '../base-node/base-node.component';
import { NodeSocketComponent } from '../node-socket/node-socket.component';

@Component({
  selector: 'app-action-node',
  imports: [CommonModule, ReteModule, NodeSocketComponent, NodeIconPipe],
  templateUrl: './action-node.component.html',
  styleUrls: ['./action-node.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    'data-testid': 'node',
  },
})
export class ActionNodeComponent extends BaseNodeComponent implements OnInit {
  public backgroundColor = signal<string>('');
  public nodeLabel = signal<string>('');

  public ngOnInit(): void {
    const data = this.data.nodeData.data;
    const application = data.application;
    const appColor = application?.color ?? generateColorRGB(application?.name);

    this.backgroundColor.set(appColor);
    this.nodeLabel.set(data.label ?? this.data.nodeData?.name ?? '');
    this.cdr.detectChanges();
  }
}
